import {createContext,useContext} from 'react';

const Context=createContext(null);
export const LibraryNativeProvider=Context.Provider;
export const useLibraryNativeTools=()=>useContext(Context);
